import React from 'react';

// components
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import dayjs from "dayjs";


class PaymentCard extends React.Component {
    render() {
        return(
            <CommonInfoTab
                groups={
                    [
                        {
                            title: 'Платеж',
                            icon: <CurrencyRubleIcon/>,
                            flat: true,
                            fields: [
                                {
                                    title: 'Сумма',
                                    value: this.props.payment.revenue,
                                    xs: 12,
                                    sm: 12,
                                    md: 4,
                                    lg: 4,
                                },
                                {
                                    title: 'Дата',
                                    value: this.props.payment.date?dayjs(this.props.payment.date).format('DD MMM YYYY'):null,
                                    xs: 12,
                                    sm: 12,
                                    md: 4,
                                    lg: 4,
                                },
                                {
                                    title: 'Получен',
                                    value: this.props.payment.approval,
                                    xs: 12,
                                    sm: 12,
                                    md: 4,
                                    lg: 4,
                                },
                            ]
                        }
                    ]
                }
            />
        )
    }
}

export default PaymentCard